module.exports = __webpack_public_path__ + "media/images/fbcalls/6-1067fc51122cb208fb0a3fac1136e06a.png";